import React from 'react';
import { features } from '../../../config/features';

interface SaveSplitButtonProps {
  onSaveAndRegenerate: () => void;
  onOpenDropdown: () => void;
  isOpen: boolean;
  isGenerating: boolean;
  bpmDirty: boolean;
  dropdownTriggerRef?: React.Ref<HTMLButtonElement>;
}

const SaveSplitButton: React.FC<SaveSplitButtonProps> = ({
  onSaveAndRegenerate,
  onOpenDropdown,
  isOpen,
  isGenerating,
  bpmDirty,
  dropdownTriggerRef,
}) => {
  const baseClasses =
    'py-2 md:py-2.5 font-bold text-[13px] md:text-sm transition-all';
  const enabledBg =
    'bg-gradient-to-r from-brand-green to-emerald-500 text-white shadow-md shadow-green-900/30 hover:from-brand-green-dark hover:to-emerald-600 active:scale-[0.98]';
  const disabledBg = 'bg-slate-700 text-slate-500 cursor-wait';

  return (
    <div className="inline-flex rounded-xl overflow-hidden shadow-md shadow-green-900/30">
      <button
        onClick={onSaveAndRegenerate}
        disabled={isGenerating}
        className={`${baseClasses} px-4 md:px-5 ${isGenerating ? disabledBg : enabledBg}`}
      >
        {isGenerating ? '保存中...' : '保存して再生成'}
      </button>
      {features.enableAudio && (
        <button
          ref={dropdownTriggerRef}
          onClick={onOpenDropdown}
          disabled={isGenerating}
          aria-label="その他の保存オプション"
          aria-haspopup="menu"
          aria-expanded={isOpen}
          aria-controls="save-actions-menu"
          className={`${baseClasses} px-2 md:px-3 border-l border-green-900/40 relative ${isGenerating ? disabledBg : enabledBg}`}
        >
          <span aria-hidden="true">▼</span>
          {bpmDirty && (
            <span
              data-testid="save-split-bpm-dirty-dot"
              className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-amber-400"
            />
          )}
        </button>
      )}
    </div>
  );
};

export default SaveSplitButton;
